/**
 * 플랜 등급 비교 — **한 곳에서만 정한다.**
 *
 * 🔴 전에는 `AppShell` 안에만 있었다. 메뉴는 그 규칙으로 감추는데 **라우트에는 가드가
 *   아예 없어서**, 주소를 직접 치면 BASIC 조직도 PRO 화면이 그려졌다. 서버는 403 인데
 *   화면은 «급여명세서가 없습니다 — 명세서 보내기로 시작하세요» 라고 했다
 *   (2026-09-09 캡처 13). 없는 게 아니라 못 쓰는 것이다.
 *
 * 규칙을 두 곳에 적으면 다음에 한쪽만 고쳐진다. 오늘까지 그 모양을 세 번 겪었다
 * (사번 매칭 사본 · decodeUploadFileName · 초기 비밀번호 규칙).
 */
const PLAN_LEVEL: Record<string, number> = { BASIC: 0, PRO: 1, ENTERPRISE: 2 }

export type MinPlan = 'PRO' | 'ENTERPRISE'

/** 이 조직이 `min` 이상인가. 조직 정보가 아직 없으면 BASIC 으로 본다 (덜 주는 쪽) */
export function meetsPlan(orgPlan: string | undefined, min: MinPlan): boolean {
  return (PLAN_LEVEL[orgPlan ?? 'BASIC'] ?? 0) >= PLAN_LEVEL[min]
}
